// extracted by mini-css-extract-plugin
module.exports = {"title":"ModalHeader_title__2dTi9","tight":"ModalHeader_tight__36coz","description":"ModalHeader_description__2a7Sx"};